import {client} from './api-client'

function inquire({data, captchaToken}) {
  return client('inquire', {data, captchaToken})
}

export {inquire}